var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{staticClass:"fill-height"},[_c('v-overlay',{staticStyle:{"z-index":"300"},attrs:{"value":_vm.loading}}),(_vm.authReady)?_c('router-view',{staticClass:"fill-height"}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }